import React from 'react';
import { Card } from "react-bootstrap";
import face_gyorgy_karolyi from "../../assets/img/face_gyorgy_karolyi.png";
import face_Tamas_Hajas from "../../assets/img/face_Tamas_Hajas.jpg";
import ShowMoreText from "react-show-more-text";
import proj_stability_of_nuclear_reactors from "../../assets/img/proj_stability_of_nuclear_reactors.png";

const Gyorgy_Karolyi_stability = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_stability_of_nuclear_reactors} />
        <br />
        <Card.Body>
          <Card.Text className="d-flex justify-content-start card-text">
            {" "}

            <div style={{ marginRight: "20px" }}>
            <img
              className="img2"
              src={face_gyorgy_karolyi}
              
            />{" "}
            <p className="text7">György Károlyi </p>
            <br />
            <p className="text8">
              Professor{" "}
            </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_Tamas_Hajas}
              
            />{" "}
            <p className="text7">Tamás Zoltán <br /> Hajas</p>
            <br />
            <p className="text8">
              Assistant Lecturer{" "}
            </p>
            </div>



          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Institute of Nuclear Techniques, BME </p>
            </div>
            <div>
            Usual modelling of nuclear reactors involve very complex multi-physics
            models using a very large number of variables. Simplified, reduced order
            models can, however, lead to important insight into the important
            characteristics of the most important processes. These simplified models
            form a dynamical system of only a few variables related to the overall
            properties of nuclear fission and the thermo-hydraulic processes. During
            this project, the stability of the fixed points of such systems are
            evaluated together with their basins of attractions. It is also of great
            importance to verify the range of the most important parameters leading
            to stable operation of the nuclear reactor.


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gyorgy_Karolyi_stability;